import _defineProperty from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

/**
 * @internal Intended for internal use - use it on your own risk
 */
export function blockNumberReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var current = state[action.chainId];

  if (!current || action.blockNumber > current) {
    return Object.assign(Object.assign({}, state), _defineProperty({}, action.chainId, action.blockNumber));
  }

  return state;
}